import axiosInstance from "./axios";
import { ResponseType } from "@/types/CommonTypes";
import { IframePageType } from "@/types/IframePageTypes";

export const iframePagesApi = {
  getAll: async (): Promise<ResponseType<IframePageType[]>> => {
    try {
      const response = await axiosInstance.get("/iframe-pages");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id: number): Promise<ResponseType<IframePageType>> => {
    try {
      const response = await axiosInstance.get(`/iframe-pages/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getByMenuCode: async (
    menuCode: string
  ): Promise<ResponseType<IframePageType>> => {
    try {
      const response = await axiosInstance.get(
        `/iframe-pages/${menuCode}/menu-code`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
